import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import TableActivas from "./TableActivas";
import TableFinalizadas from "./TableFinalizadas";

const useStylesMain = makeStyles({
  root: {
    flexGrow: 1,
    marginTop: "3em"
  }
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}));

const TabsEndowments = props => {
  const classes = useStylesMain();
  const { requests, requestsFinalized, setTabValue } = props;
  const classesTab = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setTabValue(newValue);
  };

  return (
    <Grid container className={classes.root}>
      <Grid item container xs={12} justify="center">
        <Grid item xs={1} />
        <Grid item xs={10}>
          <div className={classesTab.root}>
            <AppBar position="static">
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
                centered
              >
                <Tab
                  label="En proceso"
                  {...a11yProps(0)}
                  style={{ textTransform: "none" }}
                />
                <Tab
                  label="Finalizadas"
                  {...a11yProps(1)}
                  style={{ textTransform: "none" }}
                />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <TableActivas requests={requests} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <TableFinalizadas requestsFinalized={requestsFinalized} />
            </TabPanel>
          </div>
        </Grid>
        <Grid item xs={1} />
      </Grid>
    </Grid>
  );
};

export default TabsEndowments;

TabsEndowments.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func,
  requests: PropTypes.array,
  requestsFinalized: PropTypes.array,
  setTabValue: PropTypes.func
};
